/**
 * @generated SignedSource<<2cbfda7dfaec755720a0ac0f9c58b23a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type TranscriptModalGenerating_RedactingPreview_meetingRecording$data = {
  readonly mediaType: RecordingMediaType;
  readonly " $fragmentType": "TranscriptModalGenerating_RedactingPreview_meetingRecording";
};
export type TranscriptModalGenerating_RedactingPreview_meetingRecording$key = {
  readonly " $data"?: TranscriptModalGenerating_RedactingPreview_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModalGenerating_RedactingPreview_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModalGenerating_RedactingPreview_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "0f570073603cfa59b0f7b88481fb9ace";

export default node;
